import JobCardsController from "./job_cards_controller"

// A calendar card's event (assistants/_calendar_card): the event in the fixed right
// sidebar, the same panel the Events list opens (calendars#detail_panel) and the way a
// job card opens a posting. Where that sidebar cannot open (a phone, a page without the
// app shell) the link is followed: the event's own page.
export default class extends JobCardsController {}
